var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isAdsEmpty)?_c('div',{staticClass:"column is-12",class:{ 'is-hidden-mobile': _vm.isFromHome, 'is-hidden': _vm.isAdsEmpty },attrs:{"data-nosnippet":""}},[_c('div',{staticClass:"card just-in is-shadowless is-radiusless is-bg-grey"},[_c('div',{staticClass:"columns is-multiline"},[(!_vm.isAd1Empty)?_c('portal',{staticClass:"column is-12",class:{ 'mx-3': _vm.isFromHome && _vm.currentBreakPoint === _vm.xsBreakPoint() },attrs:{"to":"ad1-destination","disabled":!_vm.isFromHome || _vm.currentBreakPoint !== _vm.xsBreakPoint()}},[_c('lazy-component',{staticClass:"is-fullwidth",attrs:{"threshold":0.25}},[_c('LazyAdvertisement',{attrs:{"ad-unit-nl":"rectangle-nld","ad-unit-en":"rectangle-eng","size":[
              [300, 250],
              [300, 600]
            ],"size-mapping":[
              [
                [1216, 0],
                [
                  [300, 250],
                  [300, 600]
                ]
              ],
              [[769, 0], []],
              [
                [300, 0],
                [
                  [300, 250],
                  [300, 600]
                ]
              ],
              [[0, 0], []]
            ],"is-background-grey":true,"is-from-home":_vm.isFromHome,"is-empty":_vm.isAd1Empty},on:{"update:isEmpty":function($event){_vm.isAd1Empty=$event},"update:is-empty":function($event){_vm.isAd1Empty=$event}}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.isAd2Empty)?_c('portal',{staticClass:"column is-12",class:{ 'mx-3': _vm.isFromHome && _vm.currentBreakPoint === _vm.xsBreakPoint() },attrs:{"to":"ad2-destination","disabled":!_vm.isFromHome || _vm.currentBreakPoint !== _vm.xsBreakPoint()}},[_c('lazy-component',{attrs:{"threshold":0.25}},[_c('LazyAdvertisement',{attrs:{"ad-unit-nl":"tp-rectangle-nld-2","ad-unit-en":"tp-rectangle-eng-2","size":[[300, 250]],"size-mapping":[
              [
                [1216, 0],
                [300, 250]
              ],
              [[769, 0], []],
              [
                [300, 0],
                [300, 250]
              ],
              [[0, 0], []]
            ],"is-background-grey":true,"is-from-home":_vm.isFromHome,"is-empty":_vm.isAd2Empty},on:{"update:isEmpty":function($event){_vm.isAd2Empty=$event},"update:is-empty":function($event){_vm.isAd2Empty=$event}}})],1)],1):_vm._e()],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }